<template>
  <nav class="navbar">
    <div class="brand-logo">
      <img src="/img/Logo.jpg" alt="Tasoar Logo" class="logo">
    </div>

    <div class="navbar-links" :class="{ active: isMenuOpen }">
      <ul class="nav-links">
        <li><router-link to="/" @click="closeMenu">Inicio</router-link></li>
        <li><router-link to="/nosotros" @click="closeMenu">Nosotros</router-link></li>
        <li><router-link to="/servicios" @click="closeMenu">Servicios</router-link></li>
        <li><router-link to="/proyectos" @click="closeMenu">Proyectos</router-link></li>
        <li><router-link to="/clientes" @click="closeMenu">Clientes</router-link></li>
        <li><router-link to="/contacto" @click="closeMenu">Contacto</router-link></li>
      </ul>
    </div>

    <button class="toggle-button" @click="toggleMenu" aria-label="Abrir menú">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>
  </nav>
  
  <router-view />

    <footer class="footer">
    <div class="footer-bar">
      <div class="footer-item">
        <i class="fa-regular fa-envelope"></i>
        <div class="footer-text">
          <span class="footer-label">Escríbenos</span>
          <a href="mailto:smeza@tasoar.com">smeza@tasoar.com</a>
        </div>
      </div>

      <div class="footer-item">
        <i class="fa-solid fa-globe"></i>
        <div class="footer-text">
          <span class="footer-label">Visita nuestro sitio</span>
          <a href="https://www.tasoar.com" target="_blank" aria-label="Sitio web de Tasoar">www.tasoar.com</a>
        </div>
      </div>

      <div class="footer-item footer-socials">
        <span class="footer-label">Síguenos</span>
        <div class="social-icons">
          <a href="https://www.linkedin.com/company/tasoar-oficial/posts/?feedView=all" target="_blank" aria-label="LinkedIn">
            <i class="fab fa-linkedin-in"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="footer-bottom">
      <p>&copy; 2026 <strong>Tasoar</strong>. Todos los derechos reservados.</p>
      <p>Sitio web desarrollado por <a href="https://adaptivefastweb.netlify.app" target="_blank" aria-label="Tasoar Website">AdaptiveFastWeb</a></p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    closeMenu() {
      this.isMenuOpen = false;
    }
  }
};
</script>

<style>
:root{
  --color-primary: #003263;
  --color-secundary: #FFFFFF;
  --color-text: #0971ed;
}

body {
  margin: 0px;
  padding: 0px; 
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  text-align: center;
  color: #2c3e50;
  margin: 0px;
  padding: 0px; 
}

.navbar {
  position: sticky;
  top: 0;
  background-color: var(--color-secundary);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 40px; /* Más espacio a los lados */
  min-height: 80px;  /* Altura incrementada */
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0,0,0,0.15);
}

/* Contenedor de la imagen/logo */
.brand-logo .logo {
  height: 50px; /* Ajusta la altura de tu logo aquí */
  width: auto;
  display: block;
  transition: transform 0.3s ease;
}

.brand-logo .logo:hover {
  transform: scale(1.05);
}

/* Quitar viñetas y alinear horizontalmente */
.nav-links {
  display: flex;
  list-style: none; /* QUITA LAS VIÑETAS */
  margin: 0;
  padding: 0;
  gap: 25px; /* Espacio entre opciones */
}

.nav-links li a  {
  color: var(--color-primary);
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  text-transform: uppercase; 
  transition: color 0.3s;
}

.button-quotation{
  background-color: var(--color-primary);
  padding: 10px 20px;
  border-radius: 13px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--color-secundary);
  text-decoration: none;
}

.cta-button{
  color: var(--color-secundary);
  text-decoration: none;
  font-weight: 500;
  font-size: 1.1rem;
  transition: color 0.3s;
}

.nav-links li a:hover {
  color: var(--color-primary);
}

/* Estilos para el Dropdown mejorados */
.dropdown {
  position: relative;
}

.dropdown-content {
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  background-color: var(--color-primary);
  min-width: 200px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 8px 16px rgba(0,0,0,0.3);
  overflow: hidden;
}

.dropdown-content a {
  padding: 15px 20px;
  display: block;
  font-size: 0.95rem !important;
  border-bottom: 1px solid var(--color-secundary);
}

.dropdown-content a:last-child {
  border-bottom: none;
}

.dropdown:hover .dropdown-content {
  display: block;
}

/* Menú hamburguesa para móvil */
.toggle-button {
  display: none;
  flex-direction: column;
  gap: 5px;
  cursor: pointer;
  background: none;
  border: none;
}

.toggle-button .bar {
  width: 26px;
  height: 3px;
  background-color: var(--color-primary);
  border-radius: 2px;
  transition: transform 0.3s ease, opacity 0.3s ease;
}


/* footer */
.footer {
  background-color: #f4f8fc;
  color: #ffffff;
  padding: 20px 20px 30px 20px;
  margin-top: 0;
}

.footer-bar {
  max-width: 1200px;
  margin: 0 auto;
  background-color: var(--color-primary);
  border-radius: 10px;
  padding: 30px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px;
}

.footer-item {
  display: flex;
  align-items: center;
  gap: 15px;
  flex: 1;
  min-width: 220px;
  justify-content: center;
}

.footer-item:not(:last-child) {
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.footer-item > i {
  font-size: 1.6rem;
  color: #ffffff;
}

.footer-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.footer-label {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #cfe0f5;
  font-weight: 700;
  margin-bottom: 4px;
}

.footer-text a {
  color: #ffffff;
  text-decoration: none;
  font-weight: 500;
}

.footer-text a:hover {
  text-decoration: underline;
}

.footer-socials {
  flex-direction: column;
  gap: 10px;
}

.social-icons {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.social-icons a {
  color: var(--color-primary);
  background-color: #ffffff;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  transition: background-color 0.3s ease, color 0.3s ease;
}

.social-icons a:hover {
  background-color: var(--color-text);
  color: #ffffff;
}

/* Línea final de derechos reservados */
.footer-bottom {
  max-width: 1200px;
  margin: 25px auto 0 auto;
  text-align: center;
  font-size: 0.85rem;
  color: #667;
}

.footer-bottom strong {
  color: var(--color-primary);
}

.footer-bottom a {
  color: var(--color-text);
}

/* Responsivo */
@media (max-width: 768px) {
  .footer-bar {
    flex-direction: column;
    padding: 25px 20px;
  }

  .footer-item {
    flex-direction: column;
    text-align: center;
    width: 100%;
  }

  .footer-item:not(:last-child) {
    border-right: none;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    padding-bottom: 20px;
  }

  .footer-text {
    align-items: center;
    text-align: center;
  }

  .social-icons {
    justify-content: center;
  }
}

@media (max-width: 1100px) {
  .button-quotation .cta-button {
    font-size: 1rem;
  }

  .nav-links {
    gap: 15px;
  }

  .nav-links li a {
    font-size: 1rem;
  }
}

@media (max-width: 992px) {
  .navbar {
    padding: 0 20px;
    min-height: 70px;
  }

  .toggle-button {
    display: flex;
  }

  .navbar-links {
    display: none;
    position: absolute;
    top: 100%; /* Se ajusta a la altura real del navbar, sin importar si tiene 1 o 2 filas */
    left: 0;
    width: 100%;
    background-color: var(--color-primary);
    box-shadow: 0 8px 16px rgba(0,0,0,0.2);
  }

  .navbar-links.active {
    display: block;
  }

  .nav-links {
    flex-direction: column;
    gap: 0;
  }

  .nav-links li {
    width: 100%;
    border-top: 1px solid rgba(255, 255, 255, 0.15);
  }

  .nav-links li a {
    display: block;
    padding: 18px 20px;
    text-align: center;
    color: #ffffff;
  }

  .nav-links li a:hover {
    color: var(--color-text);
  }

  .dropdown-content {
    position: static;
    background-color: #00173a;
  }
}

@media (max-width: 480px) {
  .brand-logo .logo {
    height: 38px;
  }

  .navbar {
    padding: 0 15px;
  }
}

@media (max-width: 560px) {
  .navbar {
    flex-wrap: wrap;
    row-gap: 12px;
    padding: 12px 15px;
    min-height: auto;
  }

  .brand-logo {
    order: 1;
  }

  .toggle-button {
    order: 2;
  }

  /* El botón de cotización baja a su propia fila, completo (ícono + texto) */
  .button-quotation {
    order: 3;
    flex: 1 1 100%;
    justify-content: center;
  }

  .navbar-links {
    top: 100%;
  }
}

</style>